<template>
  <el-dialog title="群管理" :visible.sync="show" width="500px" :before-close="close">
    <div class="group-manage">
      <div class="all-mute-bar">
        <span class="all-mute-label">全员禁言</span>
        <span class="all-mute-tip">开启后仅群主和管理员可发言</span>
        <el-switch :value="group.isMuted" :disabled="!canManage"
          @change="onAllMuteChange"></el-switch>
      </div>
      <div class="all-mute-bar">
        <span class="all-mute-label">禁止私聊</span>
        <span class="all-mute-tip">开启后普通成员无法查看他人资料发起私聊</span>
        <el-switch :value="group.disablePrivateChat" :disabled="!canManage"
          @change="onDisablePrivateChatChange"></el-switch>
      </div>
      <div class="all-mute-bar">
        <span class="all-mute-label">隐藏普通成员</span>
        <span class="all-mute-tip">开启后普通成员仅能看到群主和管理员</span>
        <el-switch :value="group.hideMembers" :disabled="!canManage"
          @change="onHideMembersChange"></el-switch>
      </div>
      <el-divider class="divider"></el-divider>
      <el-scrollbar style="height: 400px;">
        <div v-for="member in showMembers" :key="member.userId" class="manage-member">
          <div class="member-left">
            <head-image :size="36" :name="member.showNickName" :url="member.headImage"
              :is-show-user-info="false"></head-image>
            <span class="member-name">{{ member.showNickName }}</span>
            <el-tag v-if="member.userId == group.ownerId" size="mini" type="danger" effect="dark">群主</el-tag>
            <el-tag v-else-if="member.isManager" size="mini" type="warning" effect="dark">管理</el-tag>
            <el-tag v-else-if="member.muted" size="mini" type="info" effect="plain">已禁言</el-tag>
          </div>
          <div class="member-actions">
            <el-button v-if="canSetManager(member)" size="mini" type="primary" plain
              @click="onSetManager(member)">设为管理员</el-button>
            <el-button v-if="canUnsetManager(member)" size="mini" type="warning" plain
              @click="onSetManager(member)">取消管理员</el-button>
            <el-dropdown v-if="canMute(member)" @command="(cmd) => onMute(member, cmd)">
              <el-button size="mini" type="info" plain>
                禁言<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="10">禁言10分钟</el-dropdown-item>
                <el-dropdown-item command="60">禁言1小时</el-dropdown-item>
                <el-dropdown-item command="1440">禁言1天</el-dropdown-item>
                <el-dropdown-item v-if="member.muted" command="0" divided>解除禁言</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button v-if="canRemove(member)" size="mini" type="danger" plain
              @click="onRemove(member)">移除</el-button>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </el-dialog>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

export default {
  name: "groupManage",
  components: { HeadImage },
  data() {
    return {
      show: false
    }
  },
  props: {
    group: {
      type: Object
    },
    groupMembers: {
      type: Array
    }
  },
  computed: {
    mine() {
      return this.userStore.userInfo;
    },
    isOwner() {
      return this.group.ownerId == this.mine.id;
    },
    isManager() {
      let member = this.groupMembers.find((m) => m.userId == this.mine.id);
      return member && member.isManager;
    },
    canManage() {
      return this.isOwner || this.isManager;
    },
    showMembers() {
      return this.groupMembers.filter((m) => !m.quit);
    }
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    canSetManager(member) {
      return this.isOwner && member.userId != this.group.ownerId && !member.isManager;
    },
    canUnsetManager(member) {
      return this.isOwner && member.userId != this.group.ownerId && member.isManager;
    },
    canRemove(member) {
      if (member.userId == this.group.ownerId) return false;
      if (member.userId == this.mine.id) return false;
      if (this.isOwner) return true;
      if (this.isManager) return !member.isManager;
      return false;
    },
    canMute(member) {
      if (!this.canManage) return false;
      if (member.userId == this.group.ownerId) return false;
      if (member.userId == this.mine.id) return false;
      if (this.isManager && member.isManager) return false;
      return true;
    },
    onSetManager(member) {
      this.$http({
        url: "/group/members/manager",
        method: 'put',
        data: {
          groupId: this.group.id,
          userId: member.userId,
          isManager: !member.isManager
        }
      }).then(() => {
        this.$message.success('操作成功');
        this.$emit('reload');
      })
    },
    onAllMuteChange(isMuted) {
      this.$http({
        url: "/group/mute/all",
        method: 'put',
        data: {
          groupId: this.group.id,
          isMuted: isMuted
        }
      }).then(() => {
        this.group.isMuted = isMuted;
        this.$message.success(isMuted ? '已开启全员禁言' : '已解除全员禁言');
        this.$emit('reload');
      })
    },
    onDisablePrivateChatChange(disabled) {
      this.$http({
        url: "/group/private-chat",
        method: 'put',
        data: {
          groupId: this.group.id,
          disabled: disabled
        }
      }).then(() => {
        this.group.disablePrivateChat = disabled;
        this.$message.success(disabled ? '已开启禁止私聊' : '已关闭禁止私聊');
        this.$emit('reload');
      })
    },
    onHideMembersChange(hidden) {
      this.$http({
        url: "/group/hide-members",
        method: 'put',
        data: {
          groupId: this.group.id,
          hidden: hidden
        }
      }).then(() => {
        this.group.hideMembers = hidden;
        this.$message.success(hidden ? '已开启隐藏普通成员' : '已关闭隐藏普通成员');
        this.$emit('reload');
      })
    },
    onMute(member, duration) {
      this.$http({
        url: "/group/mute/member",
        method: 'put',
        data: {
          groupId: this.group.id,
          userId: member.userId,
          duration: Number(duration)
        }
      }).then(() => {
        this.$message.success(Number(duration) > 0 ? '已禁言' : '已解除禁言');
        this.$emit('reload');
      })
    },
    onRemove(member) {
      this.$confirm(`确认将'${member.showNickName}'移出群聊吗?`, '移除成员', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: "/group/members/remove",
          method: 'delete',
          data: {
            groupId: this.group.id,
            userIds: [member.userId]
          }
        }).then(() => {
          this.$message.success('移除成功');
          this.$emit('reload');
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.group-manage {
  .all-mute-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 4px 8px;

    .all-mute-label {
      font-weight: 600;
    }

    .all-mute-tip {
      flex: 1;
      font-size: 12px;
      color: #999;
    }
  }

  .divider {
    margin: 8px 0;
  }

  .manage-member {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 4px;
    border-bottom: 1px solid #f0f0f0;

    .member-left {
      display: flex;
      align-items: center;
      gap: 8px;

      .member-name {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .member-actions {
      display: flex;
      gap: 4px;
    }
  }
}
</style>
